import { capitalize } from 'lodash';

const DAY_INTERVAL = 'day';
const generateSharedTrialLabels = (quantity, interval = DAY_INTERVAL) => {
  const capitalizedInterval = capitalize(interval);
  return {
    trialQuantity: quantity,
    trialInterval: interval,
    trialIntervalCapitalize: capitalizedInterval,
    trialLabel: `${quantity}-${capitalizedInterval} FREE Trial`,
    startTrialFreeLabel: `Start ${quantity}-${capitalizedInterval} FREE Trial`,
    startTrialFreeLabel2: `Start ${quantity}-${capitalizedInterval} Free Trial`,
    startFreeTrialLabel: `Start Free ${quantity}-${capitalizedInterval} Trial`,
    startYourFreeTrialLabel: `Start Your ${quantity}-${capitalizedInterval} Free Trial`,
  };
};

const plansToLabelMapping = {
  default: {
    ...generateSharedTrialLabels(7, DAY_INTERVAL),
    trialTerm: 'week',
  },
  '30daytrial': {
    ...generateSharedTrialLabels(30, DAY_INTERVAL),
    trialTerm: 'month',
  },
};

const DEFAULT_PLAN_TAG = 'default';
export const getPlanLabelData = planTag =>
  plansToLabelMapping[planTag] || plansToLabelMapping[DEFAULT_PLAN_TAG];

export const getPlanTrialLabelData = ({ trialDurationDays }) => {
  return generateSharedTrialLabels(trialDurationDays, DAY_INTERVAL);
};



// WEBPACK FOOTER //
// ./src/subscriptionPlans/planLabelData.js